<!-- version 2021/05/20 -->
<template>
  <div class="content-detail-row l_rwd">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style lang="sass" scoped>
.content-detail-row
  padding: 12px 0
  border-bottom: solid 1px rgba(0, 0, 0, 0.08)

  &.no-border
    border: none
  &:last-child
    border: none
</style>
